import { Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { IResponsible, IUpdateResponsible } from '@shared/interfaces';
import { IQueryResponsible } from '@shared/interfaces/queries/IQueryResponsible';
import { IPaginatedResult } from '@shared/interfaces/mailing/IPaginatedResult';
import { convertQueryToParams } from '@shared/helpers/query-converter';

@Injectable({
    providedIn: 'root'
})
export class ResponsibleService {
    constructor(public apiService: ApiService) {}

    public getAll(query: IQueryResponsible): Promise<IPaginatedResult<IResponsible>> {
        return this.apiService.get(`/responsible${convertQueryToParams<IQueryResponsible>(query)}`);
    }

    getById(id: string): Promise<IResponsible> {
        return this.apiService.get('/responsible/' + encodeURIComponent(id));
    }

    public createItem(item: IUpdateResponsible): Promise<IResponsible> {
        return this.apiService.post('/responsible', item);
    }

    public updateItem(item: IUpdateResponsible): Promise<IResponsible> {
        return this.apiService.patch('/responsible', item);
    }

    public deleteItem(item: IResponsible): Promise<boolean> {
        return this.apiService.delete(`/responsible/${encodeURIComponent(item.id)}`);
    }
}
